/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class DaprControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation invokeActorMethod
   */
  static readonly InvokeActorMethodPath = '/actors/{type}/{id}/method/{method}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invokeActorMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invokeActorMethod$Response(params: {
    type: string;
    id: string;
    method: string;
    body?: string
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DaprControllerService.InvokeActorMethodPath, 'put');
    if (params) {
      rb.path('type', params.type, {});
      rb.path('id', params.id, {});
      rb.path('method', params.method, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invokeActorMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invokeActorMethod(params: {
    type: string;
    id: string;
    method: string;
    body?: string
  },
  context?: HttpContext

): Observable<string> {

    return this.invokeActorMethod$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation invokeActorTimer
   */
  static readonly InvokeActorTimerPath = '/actors/{type}/{id}/method/timer/{timer}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invokeActorTimer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invokeActorTimer$Response(params: {
    type: string;
    id: string;
    timer: string;
    body: string
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DaprControllerService.InvokeActorTimerPath, 'put');
    if (params) {
      rb.path('type', params.type, {});
      rb.path('id', params.id, {});
      rb.path('timer', params.timer, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invokeActorTimer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invokeActorTimer(params: {
    type: string;
    id: string;
    timer: string;
    body: string
  },
  context?: HttpContext

): Observable<void> {

    return this.invokeActorTimer$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation invokeActorReminder
   */
  static readonly InvokeActorReminderPath = '/actors/{type}/{id}/method/remind/{reminder}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invokeActorReminder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invokeActorReminder$Response(params: {
    type: string;
    id: string;
    reminder: string;
    body?: string
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DaprControllerService.InvokeActorReminderPath, 'put');
    if (params) {
      rb.path('type', params.type, {});
      rb.path('id', params.id, {});
      rb.path('reminder', params.reminder, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invokeActorReminder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  invokeActorReminder(params: {
    type: string;
    id: string;
    reminder: string;
    body?: string
  },
  context?: HttpContext

): Observable<void> {

    return this.invokeActorReminder$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation healthz
   */
  static readonly HealthzPath = '/healthz';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `healthz()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthz$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DaprControllerService.HealthzPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `healthz$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  healthz(params?: {
  },
  context?: HttpContext

): Observable<void> {

    return this.healthz$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation daprSubscribe
   */
  static readonly DaprSubscribePath = '/dapr/subscribe';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daprSubscribe()` instead.
   *
   * This method doesn't expect any request body.
   */
  daprSubscribe$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DaprControllerService.DaprSubscribePath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daprSubscribe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daprSubscribe(params?: {
  },
  context?: HttpContext

): Observable<string> {

    return this.daprSubscribe$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation daprConfig
   */
  static readonly DaprConfigPath = '/dapr/config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `daprConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  daprConfig$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DaprControllerService.DaprConfigPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `daprConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  daprConfig(params?: {
  },
  context?: HttpContext

): Observable<string> {

    return this.daprConfig$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation deactivateActor
   */
  static readonly DeactivateActorPath = '/actors/{type}/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deactivateActor()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateActor$Response(params: {
    type: string;
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DaprControllerService.DeactivateActorPath, 'delete');
    if (params) {
      rb.path('type', params.type, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deactivateActor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deactivateActor(params: {
    type: string;
    id: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.deactivateActor$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
